import i18next from 'i18next';

// CYCLE_STATUS_NONE = 0
// CYCLE_STATUS_CREATED = 1
// CYCLE_STATUS_STARTING = 2
// CYCLE_STATUS_AVAILABLE = 3
// CYCLE_STATUS_WAITING = 4
// CYCLE_STATUS_COMPLETED = 5
// CYCLE_STATUS_REMOVED = 6
export const get_cycle_status_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = i18next.t('statusDesc.cycle.none');      break;
		case 1:   desc = i18next.t('statusDesc.cycle.created');   break;
		case 2:   desc = i18next.t('statusDesc.cycle.starting');  break;
		case 3:   desc = i18next.t('statusDesc.cycle.available'); break;
		case 4:   desc = i18next.t('statusDesc.cycle.waiting');   break;
		case 5:   desc = i18next.t('statusDesc.cycle.completed'); break;
		case 6:   desc = i18next.t('statusDesc.cycle.removed');   break;
		default:  desc = '';                                      break;
	}

	return desc;
}

// AREA_STATUS_NONE = 0
// AREA_STATUS_CREATED = 1
// AREA_STATUS_AVAILABLE = 2
// AREA_STATUS_DISABLED = 3
// AREA_STATUS_REMOVED = 4
export const get_route_status_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = i18next.t('statusDesc.route.none');      break;
		case 1:   desc = i18next.t('statusDesc.route.created');   break;
		case 2:   desc = i18next.t('statusDesc.route.available'); break;
		case 3:   desc = i18next.t('statusDesc.route.disabled');  break;
		case 4:   desc = i18next.t('statusDesc.route.removed');   break;
		default:  desc = '';                                      break;
	}

	return desc;
}

// LOAD_STATUS_NONE = 0
// LOAD_STATUS_CREATED = 1
// LOAD_STATUS_REVIEW = 2
// LOAD_STATUS_WAITING = 3
// LOAD_STATUS_PROCESSING = 4
// LOAD_STATUS_GOOD = 5
// LOAD_STATUS_INCOMPLETE = 6
// LOAD_STATUS_BAD = 7
// LOAD_STATUS_REMOVED = 8
// LOAD_STATUS_ERROR = 9
export const get_load_status_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = i18next.t('statusDesc.load.none');       break;
		case 1:   desc = i18next.t('statusDesc.load.created');    break;
		case 2:   desc = i18next.t('statusDesc.load.review');     break;
		case 3:   desc = i18next.t('statusDesc.load.waiting');    break;
		case 4:   desc = i18next.t('statusDesc.load.processing'); break;
		case 5:   desc = i18next.t('statusDesc.load.good');       break;
		case 6:   desc = i18next.t('statusDesc.load.incomplete'); break;
		case 7:   desc = i18next.t('statusDesc.load.bad');        break;
		case 8:   desc = i18next.t('statusDesc.load.removed');    break;
		case 9:   desc = i18next.t('statusDesc.load.error');      break;
		default:  desc = '';                                      break;
	}

	return desc;
}

// LOAD_TYPE_NONE = 0
// LOAD_TYPE_CYCLE = 1
// LOAD_TYPE_SINGLE = 2 => Reestrucutra - Realiza cambios a las rutas
// LOAD_TYPE_UPDATE = 3 => Adicional - Agrega locations a las rutas
// LOAD_TYPE_VALUES = 4 => Coordenadas - Actualiza coordenadas a las tiendas
export const get_load_type_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return i18next.t('statusDesc.load.none');
		case 1: return i18next.t('loadTypeOptions.cycle');
		case 2: return i18next.t('loadTypeOptions.single');
		case 3: return i18next.t('loadTypeOptions.restructure');
		case 4: return i18next.t('loadTypeOptions.coordinates');
		default: return i18next.t('statusDesc.load.none');
	}
}

// LOAD_SOURCE_NONE = 0
// LOAD_SOURCE_CLOUD = 1
// LOAD_SOURCE_LOCAL = 2
// LOAD_SOURCE_SERVICE = 3
// LOAD_SOURCE_OTHER = 4
export const get_load_source_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = i18next.t('statusDesc.loadSource.none');    break;
		case 1:   desc = i18next.t('statusDesc.loadSource.cloud');   break;
		case 2:   desc = i18next.t('statusDesc.loadSource.local');   break;
		case 3:   desc = i18next.t('statusDesc.loadSource.service'); break;
		case 4:   desc = i18next.t('statusDesc.loadSource.other');   break;
		default:  desc = '';                                         break;
	}

	return desc;
}

// LOAD_SCOPE_NONE = 0
// LOAD_SCOPE_GLOBAL = 1
// LOAD_SCOPE_ORGANIZATION = 2
// LOAD_SCOPE_WORKSPACE = 3
// LOAD_SCOPE_MODULE = 4
export const get_load_scope_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = i18next.t('statusDesc.loadScope.none');         break;
		case 1:   desc = i18next.t('statusDesc.loadScope.global');       break;
		case 2:   desc = i18next.t('statusDesc.loadScope.organization'); break;
		case 3:   desc = i18next.t('statusDesc.loadScope.workspace');    break;
		case 4:   desc = i18next.t('statusDesc.loadScope.module');       break;
		default:  desc = '';                                             break;
	}

	return desc;
}

// LOAD_SCHEMA_NONE = 0
// LOAD_SCHEMA_INT = 1
// LOAD_SCHEMA_FLOAT = 2
// LOAD_SCHEMA_STRING = 3
export const get_load_field_type_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = i18next.t('statusDesc.loadFieldType.none');   break;
		case 1:   desc = i18next.t('statusDesc.loadFieldType.int');    break;
		case 2:   desc = i18next.t('statusDesc.loadFieldType.float');  break;
		case 3:   desc = i18next.t('statusDesc.loadFieldType.string'); break;
		default:  desc = '';                                           break;
	}

	return desc;
}

// AREA_TYPE_NONE = 0
// AREA_TYPE_ORGANIZATION = 1
// AREA_TYPE_REGION = 2
// AREA_TYPE_ZONE = 3
// AREA_TYPE_DEPOT = 4
// AREA_TYPE_GROUP = 5
// AREA_TYPE_ROUTE = 6
// AREA_TYPE_LOCATION = 7
export const get_area_type_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = 'None';   break;
		case 1:   desc = i18next.t('filters.organization');            break;
		case 2:   desc = i18next.t('filters.region');                  break;
		case 3:   desc = i18next.t('filters.zone');                    break;
		case 4:   desc = i18next.t('filters.depot');                   break;
		case 5:   desc = i18next.t('filters.group');                   break;
		case 6:   desc = i18next.t('filters.route');                   break;
		case 7:   desc = i18next.t('statusDesc.areaType.locations');   break;
		default:  desc = 'None';                                       break;
	}

	return desc;
}

// CYCLE_SCOPE_NONE = 0
// CYCLE_SCOPE_COMPLETE = 1
// CYCLE_SCOPE_SELECTED = 2
export const get_cycle_scope_desc = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = 'None';                                        break;
		case 1:   desc = i18next.t('statusDesc.cycleScope.complete');   break;
		case 2:   desc = i18next.t('statusDesc.cycleScope.selected');   break;
		default:  desc = 'None';                                        break;
	}

	return desc;
}

// LOAD_VALUE_NONE = 0
// LOAD_VALUE_REGION = 1
// LOAD_VALUE_ZONE = 2
// LOAD_VALUE_DEPOT = 3
// LOAD_VALUE_DATA = 4
// LOAD_VALUE_GROUP = 5
// LOAD_VALUE_ROUTE = 6
// LOAD_VALUE_LOCATION = 7
// LOAD_VALUE_NAME = 8
// LOAD_VALUE_DESCRIPTION = 9
// LOAD_VALUE_LAT = 10
// LOAD_VALUE_LON = 11
// LOAD_VALUE_USER = 12
// LOAD_VALUE_FREQUENCY = 13
export const get_load_value_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return 'None';
		case 1: return 'REGION';
		case 2: return 'ZONE';
		case 3: return 'DEPOT';
		case 4: return 'DATA';
		case 5: return 'GROUP';
		case 6: return 'ROUTE';
		case 7: return 'LOCATION';
		case 8: return 'NAME';
		case 9: return 'DESCRIPTION';
		case 10: return 'LAT';
		case 11: return 'LON';
		case 12: return 'USER';
		case 13: return 'FREQUENCY';
		default: return 'None';
	}
}

// STAFF_TYPE_NONE = 0
// STAFF_TYPE_GENERAL = 1
// STAFF_TYPE_REGION = 2
// STAFF_TYPE_ZONE = 4
// STAFF_TYPE_DEPOT = 8
// STAFF_TYPE_GROUP = 16
// STAFF_TYPE_ROUTE = 32
export const get_staff_type_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 1:
			return 'General';
		case 2:
			return i18next.t('filters.workspace');
		case 4:
			return i18next.t('filters.region');
		case 8:
			return i18next.t('filters.zone');
		case 16:
			return i18next.t('filters.depot');
		case 32:
			return i18next.t('filters.group');
		case 64:
			return i18next.t('filters.route');
		default:
			return 'None';
	}
};

// LOAD_RULE_NONE = 0
// LOAD_RULE_MIN = 1
// LOAD_RULE_MAX = 2
// LOAD_RULE_VALUE = 3
// LOAD_RULE_OTHER = 4
// LOAD_RULE_COMPOSITE = 5
export const get_rule_type_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return i18next.t('statusDesc.ruleFieldType.none');
		case 1: return i18next.t('statusDesc.ruleFieldType.min');
		case 2: return i18next.t('statusDesc.ruleFieldType.max');
		case 3: return i18next.t('statusDesc.ruleFieldType.value');
		case 4: return i18next.t('statusDesc.ruleFieldType.other');
		case 5: return i18next.t('statusDesc.ruleFieldType.composite');
		default: return i18next.t('statusDesc.ruleFieldType.none');
	}
}

// RULE_ACTION_FILTER = "FILTER"
// RULE_ACTION_EXCLUDE = "EXCLUDE"
// RULE_ACTION_INCLUDE = "INCLUDE"
export const get_rule_action_desc = (status = '') => {
	switch (status) {
		case "FILTER": return i18next.t('statusDesc.ruleActionType.filter');
		case "EXCLUDE": return i18next.t('statusDesc.ruleActionType.exclude');
		case "INCLUDE": return i18next.t('statusDesc.ruleActionType.include');
		default: return i18next.t('statusDesc.ruleActionType.none');
	}
}

// RULE_OPERATOR_AND = "AND"
// RULE_OPERATOR_OR = "OR"
// RULE_OPERATOR_NOT = "NOT"
export const get_rule_operator_desc = (status = '') => {
	switch (status) {
		case "AND": return i18next.t('statusDesc.ruleOperatorType.and');
		case "OR": return i18next.t('statusDesc.ruleOperatorType.or');
		case "NOT": return i18next.t('statusDesc.ruleOperatorType.not');
		default: return i18next.t('statusDesc.ruleOperatorType.none');
	}
}

// LOAD_MOVEMENT_NONE = 0
// LOAD_MOVEMENT_NEW = 1          # Location is NEW to DB + added to route (no APPEND needed)
// LOAD_MOVEMENT_UPDATE = 2       # Location data updated (coords, name, etc) - stays in same route
// LOAD_MOVEMENT_APPEND = 3       # Existing location added to route (wasn't in ANY active route before)
// LOAD_MOVEMENT_CHANGE = 4       # Existing location moved from one active route to another
// LOAD_MOVEMENT_REMOVE = 5       # Existing location removed from active route (not moved to another)
export const get_movement_type_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return i18next.t('statusDesc.ruleFieldType.none');
		case 1: return i18next.t('statusDesc.movementType.new');
		case 2: return i18next.t('statusDesc.movementType.update');
		case 3: return i18next.t('statusDesc.movementType.append');
		case 4: return i18next.t('statusDesc.movementType.change');
		case 5: return i18next.t('statusDesc.movementType.remove');
		default: return i18next.t('statusDesc.ruleFieldType.none');
	}
}

// LOAD_WEEKDAY_MONDAY = 0
// LOAD_WEEKDAY_TUESDAY = 1
// LOAD_WEEKDAY_WEDNESDAY = 2
// LOAD_WEEKDAY_THURSDAY = 3
// LOAD_WEEKDAY_FRIDAY = 4
// LOAD_WEEKDAY_SATURDAY = 5
// LOAD_WEEKDAY_SUNDAY = 6
export const get_load_weekday_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return i18next.t('statusDesc.loadWeekday.monday');
		case 1: return i18next.t('statusDesc.loadWeekday.tuesday');
		case 2: return i18next.t('statusDesc.loadWeekday.wednesday');
		case 3: return i18next.t('statusDesc.loadWeekday.thursday');
		case 4: return i18next.t('statusDesc.loadWeekday.friday');
		case 5: return i18next.t('statusDesc.loadWeekday.saturday');
		case 6: return i18next.t('statusDesc.loadWeekday.sunday');
		default: return '';
	}
}

// LOAD_DISCARD_NONE = 0
// LOAD_DISCARD_RULES = 1         # Failed business rules validation
// LOAD_DISCARD_INACTIVE = 2      # Route not active
// LOAD_DISCARD_INVALID = 3       # Invalid/missing route code
// LOAD_DISCARD_VECTORIZED = 4    # Discarded by vectorized pre-filter
export const get_discard_type_desc = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return i18next.t('statusDesc.ruleFieldType.none');
		case 1: return i18next.t('statusDesc.discardType.rules');
		case 2: return i18next.t('statusDesc.discardType.inactive');
		case 3: return i18next.t('statusDesc.discardType.invalid');
		case 4: return i18next.t('statusDesc.discardType.vectorized');
		default: return i18next.t('statusDesc.ruleFieldType.none');
	}
}
